import dynamic from "next/dynamic";

const DynamicAdaptiveOddsserveAd = dynamic(() => import("./AdaptiveOddsserveAd"), {
  ssr: false,
});

export default DynamicAdaptiveOddsserveAd;
